var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 23,
    viewBox: "0 0 17 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 13.7214H5.5C4.948 13.7214 4.5 13.2451 4.5 12.6581C4.5 12.0712 4.948 11.5948 5.5 11.5948H8.5C9.052 11.5948 9.5 12.0712 9.5 12.6581C9.5 13.2451 9.052 13.7214 8.5 13.7214ZM4.5 16.9113C4.5 16.3243 4.948 15.848 5.5 15.848H11.5C12.053 15.848 12.5 16.3243 12.5 16.9113C12.5 17.4982 12.053 17.9746 11.5 17.9746H5.5C4.948 17.9746 4.5 17.4982 4.5 16.9113ZM13.944 20.1012H3.055C2.749 20.1012 2.5 19.863 2.5 19.5695V3.62014C2.5 3.32667 2.749 3.0885 3.055 3.0885H8.5V6.43786C8.5 8.10936 9.717 9.46824 11.214 9.46824H14.5V19.5695C14.5 19.863 14.251 20.1012 13.944 20.1012ZM10.5 4.12839L13.242 7.34166H11.214C10.82 7.34166 10.5 6.93655 10.5 6.43786V4.12839ZM16.24 7.69042L10.796 1.31067C10.606 1.08845 10.338 0.961914 10.055 0.961914H3.055C1.646 0.961914 0.5 2.15493 0.5 3.62014V19.5695C0.5 21.0347 1.646 22.2277 3.055 22.2277H13.944C15.353 22.2277 16.5 21.0347 16.5 19.5695V8.40495C16.5 8.14019 16.407 7.88607 16.24 7.69042Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.d83d4221f9eb261a49f2b01205d5811b.svg";
export { ForwardRef as ReactComponent };